import styled from 'styled-components'
import VideoCard from '../../molecules/VideoCard/VideoCard'
import media from 'styled-media-query'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'

import React, { Component } from 'react'
const Btn = styled.div`
  width: 300px;
  text-align: center;
  border-bottom: 2px solid black;
  padding-bottom: 14px;
  margin: 0 auto;
  margin-top: 20px;

  a {
    text-transform: uppercase;
    letter-spacing: 3px;
    color: 'black';
    font-size: 21px;
    text-decoration: none;
  }
`
const Style = styled.div`
  display: flex;
  gap: 24px;

  ${media.lessThan('medium')`
    &>div {
    }
    &>div:nth-child(2) {
      display: none;
    }
    &>div:nth-child(3) {
      display: none;
    }
  `}
`
const Modal = styled.div`
  background-color: rgba(0, 0, 0, 0.7);
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: 10000;
  i {
    position: absolute;
    top: 25px;
    right: 50px;
    color: white;
    font-size: 60px;
    cursor: pointer;
  }

  iframe {
    left: calc(50vw - 380px);
    width: 820px;
    height: 461px;
    top: calc(50vh - 210px);
    z-index: 9999;
    position: absolute;
    ${media.lessThan('medium')`
    top: calc(50vh - 210px);
    left: 0%;
    width: 100%; 
    height: 280px; 
  `}
  }
`

const cards = [
  {
    id: 'wOhhWoqqGwM',
    thumb:
      'https://res.cloudinary.com/rehabpath/image/upload/v1628872162/colorado-video-block-thumbnail.png',
    description: 'Experience natural beauty while in treatment.',
    location: 'Colorado'
  },
  {
    id: '7knKtfMkbHk',
    thumb:
      'https://res.cloudinary.com/rehabpath/image/upload/v1628872144/bali-video-block-thumbnail.png',
    description: 'Travel to a tropical oasis for quality treatment.',
    location: 'Bali'
  },
  {
    id: '_xV0eNZqFSo',
    thumb:
      'https://res.cloudinary.com/rehabpath/image/upload/v1628872119/arizona-video-block-thumbnail.png',
    description: 'Escape to the desert for amazing treatment.',
    location: 'Arizona'
  }
]
export const videoParams =
  'rel=0&showinfo=0&autohide=1&autoplay=1&vq=hd1080&fs=1'
export default class VideoCards extends Component {
  constructor(props) {
    super(props)
    this.state = {
      videos: [],
      open: false
    }

    this.toggleVideo = (id) => {
      this.setState({
        open: !this.state.open,
        modal: {
          id
        }
      })
    }
  }
  render() {
    return (
      <React.Fragment>
        <Style>
          {cards.map((video) => (
            <VideoCard
              key={video.id}
              title={video.location}
              desc={video.description}
              thumb={video.thumb}
              onClick={() => this.toggleVideo(video.id)}
            />
          ))}
        </Style>
        {this.state.open && (
          <Modal onClick={() => this.toggleVideo()}>
            <FontAwesomeIcon icon={faXmark} />
            <iframe
              title={this.state.modal.title}
              id="ytplayer"
              type="text/html"
              src={`https://www.youtube.com/embed/${this.state.modal.id}?${videoParams}`}
              frameBorder="0"
              allowfullscreen="allowfullscreen"
            />
          </Modal>
        )}
      </React.Fragment>
    )
  }
}
